import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { DebugDs } from './debugDs'
import type { IDebugDS } from './types'
import { TbDebugSymbol, DevToolsSymbol, DevtoolsFactory } from 'feature-debug'

export const editor: ContainerModuleLoader = (bind) => {
	bind(TbDebugSymbol).to(DebugDs)
	bind(DevToolsSymbol).to(DevtoolsFactory)
}

export { IDebugDS }
